/**
 * This is not a production server yet!
 * This is only a minimal backend to get started.
 */

import { Logger } from '@nestjs/common';
import { NestFactory } from '@nestjs/core';

import { AppModule } from './app/app.module';
import { PinoLogger } from 'nestjs-pino';
import { NestJsLogger } from '../../logger/nest-js-logger';
import { logisticsConfigs } from '../config';
import { DocumentBuilder, SwaggerModule } from '@nestjs/swagger';
import {appSettings} from '../../config';
async function bootstrap() {
  const app = await NestFactory.create(AppModule,
    { logger: new NestJsLogger( new PinoLogger({pinoHttp: {level: logisticsConfigs.loggingMode}}) ) }
  );
  app.enableCors(); 
  const globalPrefix = 'erpx';
  app.setGlobalPrefix(globalPrefix);
   const options = new DocumentBuilder()
    .setTitle('ERPX')
    .setDescription('ERPX')
    .setVersion('1.0')
    .addTag('')
    .build();
  const document = SwaggerModule.createDocument(app, options);
  SwaggerModule.setup('erpx', app, document);
  const port = appSettings.logistics_port;
  await app.listen(port, () => {
    Logger.log('Listening at http://localhost:' + port + '/' + globalPrefix);
  });
}

bootstrap();
